import { BaseFiles, ExtendedRSDocument } from '../data/rsTypes';
import { pendoSendTrackEvent } from '../Tracking';
import { getFieldsDetails, getSignInSourceMetadata } from './helper';

const NATIVE_ESIGN = 'native_esign';
const COMPUTER = 'Computer';
const SHAREFILE = 'ShareFile';

export const sendPendoTrackingEvent = function (
	signatureRequestResponse,
	eventName,
	additionalMetadata = {}
) {
	const workflow = signatureRequestResponse?.document_transaction?.workflow;
	const metadata = {
		entities: signatureRequestResponse?.roles?.map(role => role?.name),
		documentTransactionId: signatureRequestResponse?.document_transaction?.id,
		signerCount: signatureRequestResponse?.documents?.[0]?.signer_ids?.length,
		fieldCount: signatureRequestResponse?.documents?.[0]?.components?.length,
		expiresIn: signatureRequestResponse?.documents?.[0]?.expires_in,
		kba: signatureRequestResponse?.documents?.[0]?.kba,
		hasPasscode: signatureRequestResponse?.documents?.[0]?.passcode,
		signatureColor: signatureRequestResponse?.documents?.[0]?.signature_color,
		source: signatureRequestResponse?.uploads?.[0]?.from_remote_url
			? SHAREFILE
			: COMPUTER,
		pageCount: signatureRequestResponse?.base_files?.[0]?.page_count,
		fromReusableTemplate:
			signatureRequestResponse?.documents?.[0]?.from_reusable_template,
		workflow,
		isWcsWorkflow: false,
		documentSentFrom: NATIVE_ESIGN,
	};
	const metadataWithFields = {
		...metadata,
		...additionalMetadata,
		...getFieldsDetails(signatureRequestResponse?.documents?.[0]?.components || []),
	};
	pendoSendTrackEvent(eventName, metadataWithFields);
};

export const sendEsignDocumentTrackingEvent = function (
	eventName: string,
	eSignDocument: ExtendedRSDocument,
	baseFile: BaseFiles,
	signInSource: string,
	additionalMetadata = {}
) {
	const signatureRequestMetadata = {
		documentTransactionId: eSignDocument?.transaction_id,
		signerCount: eSignDocument?.signer_ids?.length,
		fieldCount: eSignDocument?.components?.length,
		expiresIn: eSignDocument?.expires_in,
		kba: eSignDocument?.kba,
		hasPasscode: eSignDocument?.passcode,
		signatureColor: eSignDocument?.signature_color,
		pageCount: baseFile?.page_count,
		fromReusableTemplate: eSignDocument?.from_reusable_template,
		workflow: eSignDocument?.workflow,
		executionFrom: NATIVE_ESIGN,
	};
	const fieldDetailsMetadata = getFieldsDetails(eSignDocument?.components || []);
	const signInSourceMetadata = getSignInSourceMetadata(signInSource);

	const metadata = {
		...additionalMetadata,
		...signatureRequestMetadata,
		...fieldDetailsMetadata,
		...signInSourceMetadata,
	};

	pendoSendTrackEvent(eventName, metadata);
};
